import * as types from '../constants/ActionTypes';

export const initialState = {
    homeworkExercises: [],
    homeworkId: '',
    homeworkSaved: false,
    isCopying: false,
    loaded: true,
    message: '',
    publicTitle: ''
};

export default function EditorialHomeworkDetailReducer(state = initialState, action = {}) {
    switch (action.type) {
        case types.GET_EDITORIAL_HOMEWORK:
            return {
                ...state,
                loaded: false
            };
        case types.GET_INVALSI_HOMEWORK:
            return {
                ...state,
                loaded: false
            };
        case types.GET_SPECIAL_HOMEWORK:
            return {
                ...state,
                loaded: false
            };
        case types.GET_EDITORIAL_HOMEWORK_SUCCESS:
        case types.GET_INVALSI_HOMEWORK_SUCCESS:
        case types.GET_SPECIAL_HOMEWORK_SUCCESS:
            return {
                ...state,
                ...action.res,
                loaded: true
            };
        case types.GET_EDITORIAL_HOMEWORK_FAILURE:
        case types.GET_INVALSI_HOMEWORK_FAILURE:
        case types.GET_SPECIAL_HOMEWORK_FAILURE:
            return {
                ...state,
                loaded: true,
                message: 'Si sono verificati errori nel recupero della verifica'
            };
        default:
            return state;
    }
}
